import React, { createContext, useContext, useState, useEffect } from 'react';
import apiBase from '../config/apiBase';

const InsightsContext = createContext({
  hasNewInsights: false,
  refreshInsightsFlag: () => {},
});

export function InsightsProvider({ children }) {
  const [hasNewInsights, setHasNewInsights] = useState(false);

  useEffect(() => {
    const url = `${apiBase}/insights/overview`;

    function safePing() {
      // Fire-and-forget; 'no-cors' avoids CORS enforcement / console noise.
      fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        cache: 'no-store',
        keepalive: true,
        credentials: 'include',
      }).catch(() => {});
    }

    safePing();
    const id = setInterval(safePing, 300000); // 5 minutes
    return () => clearInterval(id);
  }, []);

  const refreshInsightsFlag = () => setHasNewInsights(false);

  return (
    <InsightsContext.Provider value={{ hasNewInsights, refreshInsightsFlag }}>
      {children}
    </InsightsContext.Provider>
  );
}

export function useInsights() {
  return useContext(InsightsContext);
}
